"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=emoji.js.map